
import React, { Component } from "react";

class SocialLink extends Component {
    
    render() {
        return (
            <a href={this.props.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className={this.props.class }>
                <span className="label">{this.props.name}</span>
            </a>
        );
    }
}

export default SocialLink;